import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { GeniusesSection } from '../components/landing/GeniusesSection';
import { IncludesSection } from '../components/landing/IncludesSection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { AudienceSection } from '../components/landing/AudienceSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-89">
      <HeroSection data-id="element-90" />
      <ProblemSection data-id="element-91" />
      <SolutionSection data-id="element-92" />
      <GeniusesSection data-id="element-93" />
      <IncludesSection data-id="element-94" />
      <BenefitsSection data-id="element-95" />
      <AudienceSection data-id="element-96" />
      <FinalCTASection data-id="element-97" />

      <footer className="bg-[#2A180D] text-[#E0D8D0] py-12 text-center border-t border-[#3D2314]" data-id="element-98">
        <div className="max-w-7xl mx-auto px-4" data-id="element-99">
          <p className="font-serif text-xl mb-4" data-id="element-100">
            Genios que Transformaron la Humanidad
          </p>
          <p className="text-sm opacity-60" data-id="element-101">
            © 2024 Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}